import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { BetaTooltipComponent } from '@rma/dashboard/generic/ui/beta-tooltip';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { NavigationSubItem } from '../domain/entities/side-nav-items';

@Component({
  selector: 'rma-nav-menu-item',
  standalone: true,
  templateUrl: './nav-menu-item.component.html',
  styleUrls: ['./nav-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatListModule, RmaIconComponent, RouterModule, TranslocoModule, BetaTooltipComponent],
  host: {
    '[class.collapsed]': 'collapsed()',
  },
})
export class NavMenuItemComponent {
  public readonly item = input.required<NavigationSubItem>();
  public readonly isActive = input(false);
  public readonly collapsed = input(false);

  public readonly navigated = output<void>();

  public onNavigate(): void {
    this.navigated.emit();
  }
}
